module.exports = __webpack_public_path__ + "img/compra-100-segura.56e33443.svg";